import { FilterTypes } from '../constants/initialFilters';
import {
  USPromoDataLayerEvent,
  Event,
  InitialStateEventBody,
  FiltersClearEventBody,
  FilterClearEventBody,
  FilterPanelCancelEventBody,
  FiltersSaveEventBody,
  FilterPanelChangeEventBody,
  CurrentStateEventBody,
  DagLoadEventBody,
  DagLoadBody,
  FilterChangeEventTypes,
} from '../types/analytics';

type FiltersChangeSender = (changeEvent: FilterChangeEventTypes) => void;
type FiltersSnapshotSender = (
  filters: FilterTypes,
  region?: string,
  totalCount?: string | undefined,
) => void;
type FilterClearSender = (prevState: FilterTypes, removedFilter: string) => void;
type DagLoadSender = (dagData: DagLoadBody) => void;

// extend window interface so we can add a global
declare global {
  interface Window {
    ixisDataLayer: USPromoDataLayerEvent[];
  }
}
window.ixisDataLayer = window.ixisDataLayer || [];
// eslint-disable-next-line
const clone = (obj: any): any => JSON.parse(JSON.stringify(obj));

export const offersDagLoad: DagLoadSender = (dagData) => {
  const event: DagLoadEventBody = {
    type: 'offers_dag_load',
    payload: dagData,
  };

  window.ixisDataLayer.push(clone(event));
};

export const filterInitialState: FiltersSnapshotSender = (filters) => {
  const event: Event<InitialStateEventBody> = {
    promo: {
      type: 'filter_initial_state',
      payload: { ...filters },
    },
  };
  window.ixisDataLayer.push(clone(event));
};

export const filterSaveState: FiltersSnapshotSender = (filters, totalCount) => {
  const region = '';

  const event: Event<FiltersSaveEventBody> = {
    promo: {
      type: 'filter_panel_save',
      payload: { ...filters, region },
      filterResults: { totalCount },
    },
  };
  window.ixisDataLayer.push(clone(event));
};

export const filterChange: FiltersChangeSender = (changeEvent) => {
  const { payloadForIxis, latestFilterState, totalCount } = changeEvent;
  const event: Event<FilterPanelChangeEventBody> = {
    promo: {
      type: 'filter_panel_change',
      payload: [payloadForIxis],
      filters: latestFilterState,
      filterResults: {
        totalCount,
      },
    },
  };

  window.ixisDataLayer.push(clone(event));
};

export const filterCancel: FiltersSnapshotSender = (filters) => {
  const region = '';

  const event: Event<FilterPanelCancelEventBody> = {
    promo: {
      type: 'filter_panel_cancel',
      payload: { ...filters, region },
    },
  };
  window.ixisDataLayer.push(clone(event));
};

export const filterClearIndividual: FilterClearSender = (filters, filterRemoved) => {
  const region = '';

  const event: Event<FilterClearEventBody> = {
    promo: {
      type: 'filter_clear_individual',
      payload: { ...filters, region },
      removedFilter: filterRemoved,
    },
  };
  window.ixisDataLayer.push(clone(event));
};

export const filterClearAll: FiltersSnapshotSender = (filters, region) => {
  const event: Event<FiltersClearEventBody> = {
    promo: {
      type: 'filter_clear_all',
      payload: { ...filters, region },
    },
  };
  window.ixisDataLayer.push(clone(event));
};

export const filterCurrentState: FiltersSnapshotSender = (filters) => {
  const region = '';

  const event: Event<CurrentStateEventBody> = {
    promo: {
      type: 'filter_state',
      payload: { ...filters, region },
    },
  };
  window.ixisDataLayer.push(clone(event));
};
